import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Challengespoint() {
  return (
    <section
      className="challenges_point p-100 text_white bg_green_color"
      style={{ background: "#000" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center resp_order"
          >
            <div className="goals_img">
              <StaticImage
                src="../../../images/case-studies/point2-design/challenge_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={655}
                height={648}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h2>
              Project <span style={{ color: "#E8E751" }}>Challenges</span>
            </h2>
            <p>
              The main hurdle that came during the development of Point 2 Design
              was the integration with the Order Desk System. Seamless
              integration with this critical component was essential to ensure a
              smooth and efficient order-processing workflow. Hence, our team of
              tech experts utilized their expertise to overcome these challenges
              while ensuring a robust app solution.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Challengespoint;
